import styled from 'styled-components';

export const SwitchGroupLeftWrapper = styled.div`
    display: flex;
    place-self: center;
    width: auto;
    margin-right: 10px;
`;
